import { css } from 'emotion';
import React, { PureComponent } from 'react';
import {
    colors,
    fontSize,
    letterSpacing,
    lineHeight,
    mq,
    rWidth,
} from '../../../css';
import { weEmulatePeople as content } from './../content';
import Image from './../images/we_emulate_people.jpg';

export default class WeEmulatePeople extends PureComponent {
    constructor() {
        super();
    }

    render() {
        return (
            <section className={s.wrapper}>
                <div className={s.heading}>
                    <h1>{content.weEmulatePeople.heading}</h1>
                </div>
                <div className={s.content}>
                    {content.weEmulatePeople.content}
                </div>
                <div className={s.image} />
            </section>
        );
    }
}

const s = {};

s.wrapper = css`
    position: relative;
    z-index: 5;
    width: 100%;
    transition: all 0.2s;
    align-items: center;
    ${mq({
        display: ['block', 'block', 'flex'],
        flexDirection: ['column', 'column', 'row'],
        height: ['auto', 'auto', '100vh'],
    })};
`;

s.heading = css`
    display: flex;
    align-items: center;
    h1 {
        text-transform: uppercase;
        color: ${colors.blue};
        margin: 0;
        line-height: ${lineHeight(130, 108)};
        letter-spacing: ${letterSpacing(200)};
        ${mq({
            paddingBottom: [50, 50, 0],
            maxWidth: ['350px', '450px', '350px'],
            fontSize: [
                fontSize(40),
                fontSize(60),
                fontSize(40),
                fontSize(50),
                fontSize(75),
                fontSize(108),
            ],
        })};
    }
    ${mq({
        alignItems: ['center', 'center', 'flex-start'],
        width: ['auto', 'auto', 'auto', 'auto', rWidth(735)],
        height: ['250px', '400px', 'auto'],
        marginLeft: [20, 60, 50, 50, rWidth(235)],
        marginTop: [0, 0, -100, -100, -140],
    })};
`;

s.content = css`
    p {
        letter-spacing: ${letterSpacing(11)};
        line-height: ${lineHeight(32, 16)};
        color: ${colors.blue};
        margin: 0 0 2em;
        ${mq({
            maxWidth: ['100%', '100%', 700],
            fontSize: [
                fontSize(14),
                fontSize(16),
                fontSize(14),
                fontSize(16),
                fontSize(16),
            ],
        })};
    }
    ${mq({
        width: ['auto', 'auto', 'auto', 'auto', rWidth(700)],
        marginLeft: [20, 60, 65, 65, 'auto'],
        marginRight: [20, 60, 60, 60, rWidth(120)],
        paddingTop: [30, 30, 0, 0, 0],
        marginTop: [0, 0, -70, -70, -120],
    })};
`;

s.image = css`
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: url('${Image}');

    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 100%;
    z-index: -1;
    ${mq({
        height: ['250px', '400px', 'auto'],
    })}
`;



// WEBPACK FOOTER //
// ./src/components/sections/weEmulatePeople/weEmulatePeople.component.js